const minChars = 3;

export {minChars};
